import React, { useEffect, useState } from "react";
import { User } from "@/api/users";
import RigthPanel from "@/ui-controls/RigthPanel";
import DeleteUserForm from "@/components/users/DeleteUserForm";

interface Props {
  users: User[];
  onDelete: (users: User[]) => any;
  onClose: () => any;
}

const DeleteUser = (props: Props) => {
  useEffect(() => {
    setIPanelOpen(props.users.length > 0);
  }, [props.users]);

  const onCloseDeleteUserPanel = () => {
    setIPanelOpen(false);
    if (props.onClose) props.onClose();
  };

  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  return (
    <>
      <RigthPanel
        header={props.users.length > 1 ? "Deactivate Users" : "Deactivate User"}
        isOpen={isPanelOpen}
        dismissPanel={onCloseDeleteUserPanel}
        childComponent={DeleteUserForm}
        childProps={{
          users: props.users,
          onClose: () => onCloseDeleteUserPanel(),
          onDelete: (users: User[]) => {
            props.onDelete(users);
            onCloseDeleteUserPanel();
          },
        }}
      ></RigthPanel>
    </>
  );
};

export default DeleteUser;
